import React, { Component } from 'react'

import {
    Link
} from "react-router-dom";

import { _getLoginStatus, _showOverlay, _hideOverlay, time_out, refresh_time, _clearAllInterval, _clearInterval, _getUserLab } from './includes/Constants';
import { _addPriscriptionImage, _addTestReport, _bookLabTest, _getLabBooking, _updateLabBookingStatus, _updateLabTestStatus } from './api/Doctor';
import Toast from './includes/Toast';
import withNavigateHook from './includes/withNavigateHook';
import Loader from './includes/Loader';
import LabsHeader from './includes/LabsHeader';
let $ = window.$;
let date = new Date();
const startDate = date;

class LabTodayBooking extends Component {
    /**
     * 
     * @param {*} props 
     */
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            list: [],
            default_list: [],
            message: '',
            type: '',
            user_lab: {},
            visibility: 'hide',
            loader: "hide",
            set_interval_ref: 0
        }
    }


    /**
        * 
        * @returns 
        */
    componentDidMount = async () => {
        let res = await _getLoginStatus();
        //console.log(res);
        if (res['status']) {
            await this.setState({
                user: res.data
            });
            //alert(startDate)
            await $("#booking_date").datepicker({
                format: 'dd-mm-yyyy',
                autoClose: true,
                minDate: startDate
                // disableDayFn:(current_date) =>this._handleDaysDisable(current_date)
            }).datepicker("setDate", startDate);
            $('#booking_date').val(startDate.getDate() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getFullYear());

            if (res['data']['user_type'] == 'Lab') {
                let res1 = await _getUserLab();

                if (res1['status']) {
                    await this.setState({
                        user_lab: res1.data
                    });
                }
                await this._getUpdatedBooking();
                $('.fixed-action-btn').floatingActionButton();
              
            } else {
                this.props.navigation('/home');
            }

        } else {
            this.props.navigation('/home');
        }

    }


    /**
     * 
     */
    _getUpdatedBooking = async () => {

        if (typeof this.state.user_lab.id != "undefined") {
            //_showOverlay();
            this.setState({
                loader: "show"
            })
            let res1 = await _getLabBooking(this.state.user_lab.id);
            if (res1.data.response == "success") {

                this.setState({
                    list: res1.data.result,
                    default_list: res1.data.result,
                    loader: "hide"
                });
                // _hideOverlay();
            } else {
                this.setState({
                    list: [],
                    message: res1.data.error,
                    type: 'error',
                    visibility: 'show',
                    loader: "hide"
                });
                //_hideOverlay();
            }
        }
        return;
    }

    /**
     * 
     * @param {*} e 
     */
    _refreshBooking=(e)=>{
            e.preventDefault();
            this._getUpdatedBooking();
    }


    /**
         * 
         */
    _getBookingList = () => {
        let total_counter = 0;

        if (Object.keys(this.state.list).length > 0) {

            return (
                <ul className="">
                    <li className={"active"} key={"list-0"}>
                        {/* <div className="collapsible-header">
                                              <h6>{Object.keys(this.state.list)[index]}</h6>
                                        </div> */}
                        <React.Fragment key={"collapsible-body-0"}>
                            {
                                Object.values(this.state.list).map((value1, index1) => {

                                    total_counter = total_counter + 1;
                                    return (
                                        <div className="#ffffff white lighten-5 z-depth-5 mb-10">
                                            <div key={"row-" + index1} className="row p-15">
                                                <div className="col s12">
                                                    <span className="black-text">
                                                        <div className="info-row">
                                                            <p className="info-item"><b>Sr. No :</b>&nbsp;&nbsp;&nbsp;{total_counter}</p>
                                                            <p className="info-item"><b>Name :</b>&nbsp;&nbsp;&nbsp;{value1.patient_details.name}</p>
                                                        </div>
                                                        <div className="info-row">
                                                            <p className="info-item"><b>Age :</b>&nbsp;&nbsp;&nbsp;{value1.patient_details.age}&nbsp;years</p>
                                                            <p className="info-item"><b>Contact :</b>&nbsp;&nbsp;&nbsp;{value1.patient_details.phone_number}</p>
                                                        </div>
                                                        <div className="info-row">
                                                            <p className="info-item"><b>Status :</b>&nbsp;&nbsp;&nbsp;{value1.status}</p>
                                                            {/* <p className="info-item"><b>Tests:</b>&nbsp;&nbsp;&nbsp;{Object.keys(value1.lab_test).length === 0 ? 'Pending' : 'Added'}</p> */}
                                                            <p className="info-item">
                                                                <label>
                                                                    {
                                                                        value1.status == 'Pending'
                                                                            ?
                                                                            <input className="with-gap" name={"group-p-" + index1} type="radio" onClick={(e) => this._handleLabBookingtStatus(e, value1.id, 'Pending')} defaultValue={'Pending'} defaultChecked />
                                                                            :
                                                                            <input className="with-gap" name={"group-p-" + index1} type="radio" onClick={(e) => this._handleLabBookingtStatus(e, value1.id, 'Pending')} defaultValue={'Pending'} />
                                                                    }
                                                                    <span>Pending</span>
                                                                </label>
                                                                <label>
                                                                    {
                                                                        value1.status == 'Accepted'
                                                                            ?
                                                                            <input className="with-gap" name={"group-p-" + index1} type="radio" onClick={(e) => this._handleLabBookingtStatus(e, value1.id, 'Accepted')} defaultValue={'Accepted'} defaultChecked />
                                                                            :
                                                                            <input className="with-gap" name={"group-p-" + index1} type="radio" onClick={(e) => this._handleLabBookingtStatus(e, value1.id, 'Accepted')} defaultValue={'Accepted'} />
                                                                    }
                                                                    <span>Accepted</span>
                                                                </label>
                                                                <label>
                                                                    {
                                                                        value1.status == 'Denied'
                                                                            ?
                                                                            <input className="with-gap" name={"group-p-" + index1} type="radio" onClick={(e) => this._handleLabBookingtStatus(e, value1.id, 'Denied')} defaultValue={'Denied'} defaultChecked />
                                                                            :
                                                                            <input className="with-gap" name={"group-p-" + index1} type="radio" onClick={(e) => this._handleLabBookingtStatus(e, value1.id, 'Denied')} defaultValue={'Denied'} />
                                                                    }
                                                                    <span>Denied</span>
                                                                </label>
                                                                <label>
                                                                    {
                                                                        value1.status == 'Cancelled'
                                                                            ?
                                                                            <input className="with-gap" name={"group-p-" + index1} type="radio" onClick={(e) => this._handleLabBookingtStatus(e, value1.id, 'Cancelled')} defaultValue={'Cancelled'} defaultChecked />
                                                                            :
                                                                            <input className="with-gap" name={"group-p-" + index1} type="radio" onClick={(e) => this._handleLabBookingtStatus(e, value1.id, 'Cancelled')} defaultValue={'Cancelled'} />
                                                                    }
                                                                    <span>Cancelled</span>
                                                                </label>
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        <div className="info-row">
                                                            <p className="info-item detailBtn"><b>Lab Tests:</b>
                                                                &nbsp;&nbsp;&nbsp;
                                                                <Link className="center-align" to="/view-lab-test" state={{ data: value1 }}> Add Lab Tests </Link>
                                                            </p>
                                                        </div>
                                                        <hr />
                                                        {
                                                            Object.keys(value1.lab_test).length > 0 ?
                                                                Object.values(value1.lab_test).map((value2, index2) => {
                                                                    return (
                                                                        <React.Fragment>
                                                                            <div className="info-row">
                                                                                <p className="info-item"><b>Name :</b>&nbsp;&nbsp;&nbsp;{value2.test_code}</p>
                                                                                <p className="info-item">
                                                                                    <b>Status :</b>
                                                                                </p>
                                                                                <p className="info-item">
                                                                                    <label>
                                                                                        {
                                                                                            value2.status == 'Scheduled'
                                                                                                ?
                                                                                                <input className="with-gap" name={"group-" + index2} type="radio" onClick={(e) => this._handleTestStatus(e, value2.id, 'Scheduled')} defaultValue={'Scheduled'} defaultChecked />
                                                                                                :
                                                                                                <input className="with-gap" name={"group-" + index2} type="radio" onClick={(e) => this._handleTestStatus(e, value2.id, 'Scheduled')} defaultValue={'Scheduled'} />
                                                                                        }
                                                                                        <span>Scheduled</span>
                                                                                    </label>
                                                                                    <label>
                                                                                        {
                                                                                            value2.status == 'Sample Collected'
                                                                                                ?
                                                                                                <input className="with-gap" name={"group-" + index2} type="radio" onClick={(e) => this._handleTestStatus(e, value2.id, 'Sample Collected')} defaultValue={'Sample Collected'} defaultChecked />
                                                                                                :
                                                                                                <input className="with-gap" name={"group-" + index2} type="radio" onClick={(e) => this._handleTestStatus(e, value2.id, 'Sample Collected')} defaultValue={'Sample Collected'} />
                                                                                        }
                                                                                        <span>Sample Collected</span>
                                                                                    </label>
                                                                                    <label>
                                                                                        {
                                                                                            value2.status == 'Completed'
                                                                                                ?
                                                                                                <input className="with-gap" name={"group-" + index2} type="radio" onClick={(e) => this._handleTestStatus(e, value2.id, 'Completed')} defaultValue={'Completed'} defaultChecked />
                                                                                                :
                                                                                                <input className="with-gap" name={"group-" + index2} type="radio" onClick={(e) => this._handleTestStatus(e, value2.id, 'Completed')} defaultValue={'Completed'} />
                                                                                        }
                                                                                        <span>Completed</span>
                                                                                    </label>

                                                                                </p>

                                                                            </div>

                                                                            {
                                                                                value2.report == null || value2.report == ''
                                                                                    ?
                                                                                    <p className={value2.status == 'Completed' ? "" : "d-none"} id={"test-upload-" + value2.id}>
                                                                                        {/* Upload input */}
                                                                                        <b>Upload Test Report:</b>&nbsp;
                                                                                        <form method="post" onSubmit={(e) => this._handleManualBooking(e)} encType="multipart/form-data">
                                                                                            <input name="test_id" id={"test_id_" + value2.id} value={value2.id} type="hidden" />
                                                                                            <div className="input-field" >

                                                                                                <div className="file-field input-field">

                                                                                                    <div className="btn">

                                                                                                        <span><i className="material-icons">upload_file</i></span>

                                                                                                        <input type="file" name="test_report" accept=".pdf,image/*" />

                                                                                                    </div>

                                                                                                    <div className="file-path-wrapper">

                                                                                                        <input className="file-path validate" type="text" placeholder="Upload Test Report" />

                                                                                                    </div>

                                                                                                </div>

                                                                                            </div>
                                                                                            <button type="submit" className="btn btn-xs btn-primary continuebtn">Upload</button>

                                                                                        </form>
                                                                                    </p>
                                                                                    :
                                                                                    <div className="info-row">
                                                                                        <p className="info-item detailBtn"><b>Test Report :</b>&nbsp;&nbsp;&nbsp;

                                                                                            <a href={"https://oparchee.com/server/files/" + value2.report} className="center-align" target='_blank' download={'downlaod'}>Download {value2.test_code} report </a>
                                                                                        </p>
                                                                                        {/* <p className="info-item"><b>Tests:</b>&nbsp;&nbsp;&nbsp;{Object.keys(value1.lab_test).length === 0 ? 'Pending' : 'Added'}</p> */}
                                                                                    </div>

                                                                            }





                                                                        </React.Fragment>
                                                                    )

                                                                })
                                                                :
                                                                ''
                                                        }
                                                        <hr />

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </React.Fragment>
                    </li>
                </ul>
            )

        } else {
            return (

                <div className="col s12 center-align mt-20">
                    <img src="images/not-found.gif" alt="" className="circle responsive-img" />

                </div>

            )
        }

    }

    /**
        * 
        * @param {*} e 
        */
    async _handleManualBooking(e) {
        e.preventDefault();
        await this.setState({
            loader: "show",
        })
        // _showOverlay();
        const data = new FormData(e.target);
        let test_report = data.get('test_report');
        let test_id = data.get('test_id');

        let reg = await _addTestReport(test_id, test_report);
        if (reg.data.response == 'success') {
            $('#test-upload-' + test_id).addClass('d-none')
            this.setState({
                message: reg.data.message,
                type: 'success',
                visibility: 'show',
                loader: "hide"
            });

        } else {
            this.setState({
                message: reg.data.error,
                type: 'error',
                visibility: 'show',
                loader: "hide"
            });
            //_hideOverlay();
        }
    }


    /**
     * 
     * @param {*} e 
     * @param {*} test_id 
     * @param {*} status 
     */
    _handleTestStatus = async (e, test_id, status) => {
        // e.preventDefault();
        await this.setState({
            loader: "show",
            message: '',
            type: 'success',
            visibility: 'hide'
        })

        let reg = await _updateLabTestStatus(test_id, status);
        if (reg.data.response == 'success') {
            $('#test-upload-' + test_id).removeClass('d-none');
            this.setState({
                message: reg.data.message,
                type: 'success',
                visibility: 'show',
                loader: "hide"
            });

            //_hideOverlay();
        } else {
            this.setState({
                message: reg.data.error,
                type: 'error',
                visibility: 'show',
                loader: "hide"
            });
            //_hideOverlay();
        }
    }

    _handleLabBookingtStatus = async (e, lab_booking_id, status) => {
        // e.preventDefault();
        await this.setState({
            loader: "show",
            message: '',
            type: 'success',
            visibility: 'hide'
        })

        let reg = await _updateLabBookingStatus(lab_booking_id, status);
        if (reg.data.response == 'success') {
            //$('#test-upload-' + test_id).removeClass('d-none');
            this.setState({
                message: reg.data.message,
                type: 'success',
                visibility: 'show',
                loader: "hide"
            });

            //_hideOverlay();
        } else {
            this.setState({
                message: reg.data.error,
                type: 'error',
                visibility: 'show',
                loader: "hide"
            });
            //_hideOverlay();
        }
    }




    /**
     * 
     * @returns 
     */
    render() {
        return (
            <React.Fragment>
                <Loader visibility={this.state.loader} />
                <LabsHeader />
                <main role="main">
                    <section id="doctor_dashboard-page" className="oparcheecommonCode">
                        <div className="doctor_dashboardContent">
                            <div className="container">
                                <div className="row">
                                    <div className="col s12 mt-10 ">
                                        <div className="strip z-depth-5">
                                            <div className="row">
                                                <div className="col s3 left-align">

                                                    {/* <i className="material-icons">chevron_left</i> */}

                                                </div>
                                                <div className="col s6 center-align">
                                                    <div className="bookingTxt"><h3>
                                                        <i className="material-icons">calendar_today</i>
                                                        <span>Today's Lab Parchee</span></h3></div>
                                                </div>
                                                <div className="col s3 right-align">

                                                    {/* <i className="material-icons">chevron_right</i> */}

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="col s12 mt-10">
                                        <div className="locationName center-align z-depth-5" id="stickySearch">
                                            <form className="navbar-form" role="search" autoComplete="off">
                                                <div className="input-group" id="searchDiv">
                                                    <input type="text" className="form-control" onKeyUp={(e) => {
                                                        //this._handleFilter(e)
                                                    }} placeholder="Search..." name="filter-doc" id="filter-doc" />
                                                    <div className="input-group-btn">
                                                        <button className="btn btn-default searchBtn" type="btn">
                                                            <i className="material-icons">search</i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                    </div> */}

                                    <div className="col s12 mt-10">
                                        {
                                            this._getBookingList()
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>


                    </section>

                    {/* <!-- Floating Action Button with "Refresh" --> */}
                    <div className="fixed-action-btn">
                        <Link to="/" onClick={(e)=>this._refreshBooking(e)} className="btn-floating btn-large red tooltipped" data-tooltip="Refresh">
                            <i className="material-icons">refresh</i>
                        </Link>
                    </div>
                </main>
                {
                    // this._followUpBookingModal()
                }
                <Toast message={this.state.message} type={this.state.type} visibility={this.state.visibility} />
            </React.Fragment >
        );
    }
}
export default withNavigateHook(LabTodayBooking);
